import React from 'react';
import PageTitle from 'modules/common/components/PageTitle';
import AppBannerLayout from 'modules/partial/BannerLayout';
import LoginForm from '../forms/LoginForm';

function Login() {
  return (
    <>
      <PageTitle title="Login | Manila E-Citizen" />
      <AppBannerLayout>
        <div className="flex flex-col justify-center">
          <div className="my-12">
            <div className="mb-8">
              <h4 className="text-lg text-primary-500 font-semibold">
                Welcome,
              </h4>
              <p className="text-base text-gray-400 text-opacity-75 font-light">
                Login to your account
              </p>
            </div>
            <LoginForm />
          </div>
        </div>
      </AppBannerLayout>
    </>
  );
}
Login.defaultProps = {};

Login.propTypes = {};

export default Login;
